import React from 'react';
import s from './ToolsButtons.module.css';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCurrentProject } from '../../../../store/selectors/projectSelectors';
import IconDelete from '../../../../shared/ui/icons/IconDelete';
import { useAppDispatch } from '../../../../store/store';
import {
    selectSelectedImage,
    selectImageProject,
    selectImageLayout,
} from '../../../../store/selectors/imageSelectors';
import { deleteImageLayout, deleteImageFromLayout } from '../../../../shared/api/imageLayoutApi';
import { setSelectedImage } from '../../../../store/slices/imageSlice';
import { toast } from 'react-toastify';
const DeleteButton = () => {
    const dispatch = useAppDispatch();
    const selectedImage = useSelector(selectSelectedImage);
    const imageLayout = useSelector(selectImageLayout);
    const imageProject = useSelector(selectImageProject);
    const { projectId } = useParams();

    const shouldShowButton =
        selectedImage.image ||
        (!selectedImage.image && imageProject?.layouts && imageProject.layouts.length > 1);

    const handleDelete = async () => {
        if (selectedImage.image && imageLayout?.id) {
            try {
                await dispatch(
                    deleteImageFromLayout({
                        layoutId: imageLayout.id,
                        imageId: selectedImage.image.id,
                    }),
                );
                dispatch(setSelectedImage({ image: null, layoutId: null }));
                toast.success('Image deleted successfully');
            } catch (error: any) {
                toast.error(error?.message || 'Failed to delete image');
            }
        } else if (!selectedImage.image && projectId && imageLayout) {
            try {
                await dispatch(
                    deleteImageLayout({ imageProjectId: projectId, layoutId: imageLayout.id }),
                );
                toast.success('Layout deleted successfully');
            } catch (error: any) {
                toast.error(error?.message || 'Failed to delete layout');
            }
        }
    };

    if (!shouldShowButton) {
        return null;
    }

    return (
        <button className={s.container} onClick={handleDelete}>
            <IconDelete width={25} height={25} />
            <p>Delete</p>
        </button>
    );
};

export default DeleteButton;
